export const listFestivals = /* GraphQL */ `
    query ListFestivals(
        $id: ID
        $filter: ModelFestivalFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listFestivals(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                slug
                name
                site
                zone {
                    id
                    name
                }
                state {
                    enabled
                }
                createdAt
                updatedAt
            }
            nextToken
        }
    }
`;

export const updateFestival = /* GraphQL */ `
    mutation UpdateFestival(
        $input: UpdateFestivalInput!
        $condition: ModelFestivalConditionInput
    ) {
        updateFestival(input: $input, condition: $condition) {
            id
            slug
            name
            zone {
                id
                name
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const deleteFestival = /* GraphQL */ `
    mutation DeleteFestival(
        $input: DeleteFestivalInput!
        $condition: ModelFestivalConditionInput
    ) {
        deleteFestival(input: $input, condition: $condition) {
            id
            slug
            name
            zone {
                id
                name
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

export const onCreateFestival = /* GraphQL */ `
    subscription OnCreateFestival {
        onCreateFestival {
            id
            slug
            name
            zone {
                id
                name
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onUpdateFestival = /* GraphQL */ `
    subscription OnUpdateFestival {
        onUpdateFestival {
            id
            slug
            name
            zone {
                id
                name
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;
export const onDeleteFestival = /* GraphQL */ `
    subscription OnDeleteFestival {
        onDeleteFestival {
            id
            slug
            name
            zone {
                id
                name
            }
            state {
                enabled
            }
            createdAt
            updatedAt
        }
    }
`;

export const listZones = /* GraphQL */ `
    query ListZones(
        $id: ID
        $filter: ModelZoneFilterInput
        $limit: Int
        $nextToken: String
        $sortDirection: ModelSortDirection
    ) {
        listZones(
            id: $id
            filter: $filter
            limit: $limit
            nextToken: $nextToken
            sortDirection: $sortDirection
        ) {
            items {
                id
                name
                counties
            }
            nextToken
        }
    }
`;
